import ReportHub from '@tencent/data-report-hub-sdk';
import _ from 'lodash';
import globalStore from '@/stores';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import { matchPath } from 'react-router-dom';
import { EMBEDDED_PATH_MAP } from '@/app/embedded';

const reportHub = new ReportHub({
  appId: '62d7617032b9e1015f9058a0',
  enableReport: process.env.DEPLOY_ENV === 'production',
  spa: true,
  include: ['#root'],
  urlHandler: () => {
    const { pathname, hash } = window.location;
    const filteredPath = pathname.replace(/(\d)+/ig, '');
    // 对外iframe页面路径增加hash
    if (filteredPath.startsWith(`${REACT_APP_PUBLIC_URL}/embedded.html`)) {
      return `${filteredPath}${hash}`;
    }
    return filteredPath;
  },
  beforeUpload: (data: any) => {
    // 数据上传增加页面模块
    const pathTreeMap = globalStore.account?.siteMap?.pathTreeMap || {};
    const url = data.path?.replace(REACT_APP_PUBLIC_URL, '');
    let pageModule: string[] = [];
    if (url === '' || url === '/') { // 页面加载时认为进入首页
      pageModule = ['首页'];
    } else if (url.startsWith('/embedded.html#')) { // 对外提供iframe页面
      pageModule = getPageModule(url, EMBEDDED_PATH_MAP);
    } else { // 内部页面
      pageModule = getPageModule(url, pathTreeMap);
    }
    data.other_fields.push({ field: 'page_module', value: _.compact(pageModule).join('-') });

    return data;
  },
});

const getPageModule = (url: string, treeMap: Record<string, string[]>) => {
  let pageModule: string[] = [];
  if (treeMap[url]) { // 路径完全匹配
    pageModule = treeMap[url];
  } else { // 寻找匹配路径
    Object.keys(treeMap).some((path: string) => {
      if (matchPath(url, path)) {
        pageModule = treeMap[path];
        return true;
      }
      return false;
    });
  }
  return pageModule;
};

export default reportHub;
